
const ErrorPage = () => (
    <div>ERROR</div>
    //   <Spinner />
);

export default ErrorPage;
